<template>
  <page-content title="Daftar Psikolog" :with-margin="false">
    <empty-state
      v-if="psychologists.length === 0"
      icon="event_note"
      icon-type="rounded"
    />
    <br />
    <div v-for="(psychologist, index) in psychologists" :key="psychologist.id">
      <div class="d-flex align-items-center px-3 py-2">
        <span class="flex-grow-1 d-flex flex-column">
          <div>{{ psychologist.name }}</div>
          <div class="d-flex gap-2 text-gray">
            <small class="d-flex align-items-center">
              <material-icon name="email" type="outlined" size="12" />
              <span class="ml-1">{{ psychologist.email }}</span>
            </small>
            <small class="d-flex align-items-center">
              <material-icon name="phone_iphone" type="outlined" size="12" />
              <span class="ml-1">{{ psychologist.phone }}</span>
            </small>
          </div>
        </span>
        <span v-if="!psychologist.is_active" class="badge badge-danger">
          Tidak Aktif
        </span>
        <span
          v-if="can('update-mental-health-psychologist')"
          class="ml-1 p-1 pointer"
          @click="editPsychologist(psychologist)"
          v-tooltip="'Ubah'"
        >
          <material-icon name="edit_note" size="14" />
        </span>
      </div>
      <div v-if="index !== psychologists.length - 1" class="divider"></div>
    </div>
    <!-- FAB -->
    <button
      v-if="can('create-mental-health-psychologist')"
      class="btn btn-success btn-rounded btn-fab d-flex align-items-center"
      @click="addPsychologist()"
    >
      <material-icon name="add" size="20" class="mr-1" />
      <span class="mr-1">Tambah Psikolog</span>
    </button>
    <!-- Create psychologist dialog -->
    <sweet-modal
      ref="psychologistForm"
      :title="formTitle"
      overlay-theme="dark"
      blocking
    >
      <c-input
        label="Nama Lengkap"
        placeholder="Masukkan nama lengkap"
        v-model="form.name"
        :error="!isEmpty(errors.name)"
        :error-message="errors.name"
      />
      <c-input
        label="Email"
        placeholder="Masukkan email"
        v-model="form.email"
        :error="!isEmpty(errors.email)"
        :error-message="errors.email"
      />
      <c-input
        label="Nomor HP (WhatsApp)"
        placeholder="Masukkan nomor hp"
        v-model="form.phone"
        :error="!isEmpty(errors.phone)"
        :error-message="errors.phone"
      />
      <c-input-radio label="Status">
        <c-input-radio-item
          v-model="form.isActive"
          :c-value="1"
          text="Aktif"
          name="isActive"
        />
        <c-input-radio-item
          v-model="form.isActive"
          :c-value="0"
          text="Tidak Aktif"
          name="isActive"
        />
      </c-input-radio>
      <button-loading
        class="btn btn-primary btn-block"
        @click="storePsychologist()"
        :loading="saveLoading"
        :loading-color="colorPrimary"
      >
        Simpan
      </button-loading>
    </sweet-modal>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";
import { SweetModal } from "sweet-modal-vue";
import { camelize, decamelize } from "@ridi/object-case-converter";
import { populateFormErrors, resetFormErrors } from "@/helpers/form";

export default {
  name: "mental-health-psychologist-list",
  components: {
    SweetModal,
  },
  data() {
    return {
      formBehavior: "add", // add or edit
      form: {
        id: "",
        name: "",
        email: "",
        phone: "",
        isActive: 1,
      },
      errors: {
        name: "",
        email: "",
        phone: "",
        isActive: "",
      },
      saveLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      psychologists: "mentalHealth/psychologist/psychologists",
    }),
    formTitle() {
      return this.formBehavior === "add" ? "Tambah Psikolog" : "Ubah Psikolog";
    },
  },
  methods: {
    addPsychologist() {
      // Reset form
      resetFormErrors(this.form);

      this.openPsychologistFormModal("add");
    },
    editPsychologist(psychologist) {
      this.form.id = psychologist.id;
      this.form.name = psychologist.name;
      this.form.email = psychologist.email;
      this.form.phone = psychologist.phone;
      this.form.isActive = psychologist.is_active;

      this.openPsychologistFormModal("edit");
    },
    openPsychologistFormModal(behavior = "add") {
      this.formBehavior = behavior;
      this.$refs.psychologistForm.open();
    },
    closePsychologistFormModal() {
      this.$refs.psychologistForm.close();
    },
    storePsychologist() {
      this.saveLoading = true;
      resetFormErrors(this.errors);

      const { id, ...formData } = decamelize(this.form);

      const form = {
        ...(this.formBehavior === "edit" && { id }),
        ...formData,
      };

      const action = this.formBehavior === "edit" ? "update" : "add";

      this.$store
        .dispatch(`mentalHealth/psychologist/${action}`, form)
        .then(() => {
          this.saveLoading = false;

          // Reset form value
          resetFormErrors(this.form);

          this.$toasted.success("Psikolog berhasil disimpan.");
          this.closePsychologistFormModal();
        })
        .catch((error) => {
          this.saveLoading = false;

          const response = error.response;
          const code = response.status;

          if (code === 422) {
            populateFormErrors(this.errors, camelize(response.data.message));
            this.$toasted.error("Data belum benar.");
          } else {
            this.$toasted.error("Terjadi kesalahan.");
          }
        });
    },
  },
  created() {
    this.startPageLoading();
    this.$store
      .dispatch("mentalHealth/psychologist/getAll")
      .then(() => {
        this.stopPageLoading();
      })
      .catch(() => {
        this.stopPageLoading();
      });
  },
};
</script>
